import { UserType } from '../../entities';
import { AppSecurityRight, CrmSecurityRight, DashboardSecurityRight, IndividualComplianceSecurityModule } from '../modules';
import { SecurityRole, SecurityRoleType } from '../security.role';


export class EmployeeCompliance implements SecurityRole {

    _id = 'ea005bb7-62b3-4d2c-afb5-52eeb461be53';
    system = true;
    hidden = false;
    name = SecurityRoleType.EmployeeCompliance;
    type = UserType.Employee;
    description = 'Can manage individual compliance.';
    rights = [
        AppSecurityRight.LoginWeb,
        ...new IndividualComplianceSecurityModule().allRights,
        CrmSecurityRight.CanAccess,
        CrmSecurityRight.ManageEmployees,
        CrmSecurityRight.ManageSubcontractors,
        // DashboardSecurityRight.CanViewSystemDashboards,
        DashboardSecurityRight.CanCreateDashboards,
    ];

}

